<template>
  <div :class="{ wide: !formatAmount && amount >= 99, zero: isZero }" class="base-notification">
    {{ formattedAmount }}
  </div>
</template>

<script>
export default {
  name: 'BaseNotification',
  props: {
    amount: {
      type: Number,
      required: true,
    },
    formatAmount: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formattedAmount() {
      if (this.formatAmount) {
        return this.amount <= 99 ? this.amount.toString() : '99+';
      } else {
        return this.amount.toString();
      }
    },
    isZero() {
      return this.amount === 0;
    },
  },
};
</script>

<style lang="scss">
.base-notification {
  align-items: center;
  background-color: $color-accent-500;
  border-radius: $badge-notification-size;
  color: $color-white;
  display: inline-flex;
  font-size: 10px;
  font-weight: bold;
  height: $badge-notification-size;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: $badge-notification-size;
  font-variant-numeric: tabular-nums;

  &.wide {
    padding: 6px;
    width: auto;
  }

  &.zero {
    background-color: $color-normal-pale;
  }
}
</style>
